import { AuthStatePresenter } from '@/presentation/presenters/auth/authStatePresenter'
import { AuthStateViewModel } from '@/presentation/viewmodels/auth/authStateViewModel'

export function useAuthStatePresenter(
  presenter: AuthStatePresenter = new AuthStatePresenter(new AuthStateViewModel())
) {
  return {
    user: presenter.user,
    isLogin: presenter.isLogin,
    isLoading: presenter.isLoading,
    error: presenter.error,
    checkSession: presenter.checkSession.bind(presenter),
    login: presenter.login.bind(presenter),
    logout: presenter.logout.bind(presenter),
    registerUser: presenter.registerUser.bind(presenter)
  }
}
